var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deleteShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "delete" } }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("language.common.delete")))]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.deleteShow = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm.$route.query.cloudType == "outlook"
            ? _c(
                "div",
                {
                  staticClass: "delete-content",
                  staticStyle: { "line-height": "20px", padding: "25px 20px" }
                },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "language.popup.cloudExploerPopup.deleteContentEver"
                        )
                      )
                    }
                  })
                ]
              )
            : _c("div", { staticClass: "delete-content" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("language.popup.cloudExploerPopup.deleteContent")
                    )
                  )
                ])
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "delete-footer" }, [
            _c(
              "button",
              {
                staticStyle: { float: "right" },
                on: { click: _vm.deleteItemsStart }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("language.common.delete")) +
                    "(" +
                    _vm._s(_vm.deleteList.length) +
                    ")"
                )
              ]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-545316be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-545316be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_exploer_popups/delete_popup.vue
// module id = null
// module chunks = 